module.exports = __webpack_public_path__ + "img/location.6cc17731.png";